/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line import/no-cycle
import { track } from '../instrumentation/Track';

export const trackOnInactionError = (fields = {}) => track('track_on_inaction_error', fields);

export const trackHandleInactionError = (fields = {}) =>
  track('track_handle_inaction_error', fields);

export const trackCleanupMissingInActionEventError = (fields = {}) =>
  track('track_cleanup_missing_in_action_event_error', fields);

export const trackTriggerError = (fields = {}) => track('track_trigger_error', fields);

export const trackIsLoggedInError = (fields = {}) => track('track_is_logged_in_error', fields);

export const trackLoginError = (fields = {}) => track('track_login_error', fields);

export const trackGetAllowedCustomersError = (fields = {}) =>
  track('track_get_allowed_customers_error', fields);

export const trackSelectCustomersError = (fields = {}) =>
  track('track_select_customers_error', fields);

export const trackLoadUserSettingsError = (fields = {}) =>
  track('track_load_user_settings_error', fields);

export const trackMultiGetError = (fields = {}) => track('track_multi_get_error', fields);

export const trackCheckPinError = (fields = {}) => track('track_check_pin_error', fields);

export const trackUpdateDeviceError = (fields = {}) => track('track_update_device_error', fields);

export const trackGetDeviceInfoError = (fields = {}) =>
  track('track_get_device_info_error', fields);

export const trackCheckDeviceNameError = (fields = {}) =>
  track('track_check_device_name_error', fields);

export const trackGetAvailableConfigsError = (fields = {}) =>
  track('track_get_available_configs_error', fields);

export const trackSetConfigError = (fields = {}) => track('track_set_config_error', fields);

export const trackGetStripeConnectionTokenError = (fields = {}) =>
  track('track_get_stripe_connection_token_error', fields);

export const trackCreateStripePaymentIntentError = (fields = {}) =>
  track('track_create_stripe_payment_intent_error', fields);

export const trackGetReaderError = (fields = {}) => track('track_get_reader_error', fields);

export const trackGetCurrentPositionError = (fields = {}) =>
  track('track_get_current_position_error', fields);

export const trackGetPositionAndDistanceError = (fields = {}) =>
  track('track_get_position_and_distance_error', fields);

export const trackUpdatePrintJobsError = (fields = {}) =>
  track('track_update_print_jobs_error', fields);

export const trackHandheldPollError = (fields = {}) => track('track_handheld_poll_error', fields);

export const trackSubmitOrderError = (fields = {}) => track('track_error', fields);

export const trackProblemSettingUpPrinterControllerError = (fields = {}) =>
  track('track_problem_setting_up_printer_controller_error', fields);

export const trackHandlePrintJobsError = (fields = {}) =>
  track('track_handle_print_jobs_error', fields);

export const trackEditTabTipError = (fields = {}) => track('track_edit_tab_tip_error', fields);

export const trackUpdateNoticesError = (fields = {}) => track('track_update_notices_error', fields);

export const trackResetAudioError = (fields = {}) => track('track_reset_audio_error', fields);

export const trackShowOrderNotificationError = (fields = {}) =>
  track('track_show_order_notification_error', fields);

export const trackPlayNotificationSoundError = (fields = {}) =>
  track('track_play_notification_sound_error', fields);

export const trackCheckConnectionError = (fields = {}) =>
  track('track_check_connection_error', fields);

export const trackGetLocationDetailsError = (fields = {}) =>
  track('track_get_location_details_error', fields);

export const trackClearLocationError = (fields = {}) => track('track_clear_location_error', fields);

export const trackClearZoneGuestsError = (fields = {}) =>
  track('track_clear_zone_guests_error', fields);

export const trackStockUpdateError = (fields = {}) => track('track_stock_update_error', fields);

export const trackSearchOrdersError = (fields = {}) => track('track_search_orders_error', fields);

export const trackGetCartPriceError = (fields = {}) => track('track_get_cart_price_error', fields);

export const trackCheckDeliverableError = (fields = {}) =>
  track('track_check_deliverable_error', fields);

export const trackSetItemsStatusError = (fields = {}) =>
  track('track_set_items_status_error', fields);

export const trackAddOrderRefundError = (fields = {}) =>
  track('track_add_order_refund_error', fields);

export const trackRefundOrderItemsAndFeesError = (fields = {}) =>
  track('track_refund_order_items_and_fees_error', fields);

export const trackModifyOrderError = (fields = {}) => track('track_modify_order_error', fields);

export const trackClaimItemsError = (fields = {}) => track('track_claim_items_error', fields);

export const trackSeatGroupError = (fields = {}) => track('track_seat_group_error', fields);

export const trackEditGroupError = (fields = {}) => track('track_edit_group_error', fields);

export const trackMoveGroupError = (fields = {}) => track('track_move_group_error', fields);

export const trackAddCardToGroupError = (fields = {}) =>
  track('track_add_card_to_group_error', fields);

export const trackSaveReusableCardError = (fields = {}) =>
  track('track_save_reusable_card_error', fields);

export const trackGetCardsError = (fields = {}) => track('track_get_cards_error', fields);

export const trackOpenTabError = (fields = {}) => track('track_open_tab_error', fields);

export const trackFundTabFromPaymentIntentError = (fields = {}) =>
  track('track_fund_tab_from_payment_intent_error', fields);

export const trackExpandConsumerTabError = (fields = {}) =>
  track('track_expand_consumer_tab_error', fields);

export const trackGetTabURLError = (fields = {}) => track('track_get_tab_url_error', fields);

export const trackGetTabInfoError = (fields = {}) => track('track_get_tab_info_error', fields);

export const trackSendReceiptError = (fields = {}) => track('track_send_receipt_error', fields);

export const trackPrintTicketError = (fields = {}) => track('track_print_ticket_error', fields);

export const trackPrintTicketLocalError = (fields = {}) =>
  track('track_print_ticket_local_error', fields);

export const trackPrintReceiptLocalError = (fields = {}) =>
  track('track_print_receipt_local_error', fields);

export const trackPrintPdfWebError = (fields = {}) => track('track_print_pdf_web_error', fields);

export const trackSnoozeOrderError = (fields = {}) => track('track_snooze_order_error', fields);

export const trackTextPatronAgainError = (fields = {}) =>
  track('track_text_patron_again_error', fields);

export const trackTipReportError = (fields = {}) => track('track_tip_report_error', fields);

export const trackCloseTabsError = (fields = {}) => track('track_close_tabs_error', fields);

export const trackRenameTabError = (fields = {}) => track('track_rename_tab_error', fields);

export const trackUpdateTabError = (fields = {}) => track('track_update_tab_error', fields);

export const trackToggleFulfillmentMethodError = (fields = {}) =>
  track('track_toggle_fulfillment_method_error', fields);

export const trackSetMenusAllowedError = (fields = {}) =>
  track('track_set_menus_allowed_error', fields);

export const trackGetLocationOrderAllowedError = (fields = {}) =>
  track('track_get_location_order_allowed_error', fields);

export const trackSetLocationOrderAllowedError = (fields = {}) =>
  track('track_set_location_order_allowed_error', fields);

export const trackSetOrderAllowedError = (fields = {}) =>
  track('track_set_order_allowed_error', fields);

export const trackSetServiceConditionsError = (fields = {}) =>
  track('track_set_service_conditions_error', fields);

export const trackCloseOpenOrdersError = (fields = {}) =>
  track('track_close_open_orders_error', fields);

export const trackKdsImageError = (fields = {}) => track('track_kds_image_error', fields);

export const trackGetCourierCapabilitiesError = (fields = {}) =>
  track('track_get_courier_capabilities_error', fields);

export const trackCancelDriverError = (fields = {}) => track('track_cancel_driver_error', fields);

export const trackChangeDriverTimeError = (fields = {}) =>
  track('track_change_driver_time_error', fields);

export const trackGetInventoryDetailsError = (fields = {}) =>
  track('track_get_inventory_details_error', fields);

export const trackEditInventoryItemError = (fields = {}) =>
  track('track_edit_inventory_item_error', fields);

export const trackCreateEditMenuItemError = (fields = {}) =>
  track('track_create_edit_menu_item_error', fields);

export const trackGetMoreNotificationsError = (fields = {}) =>
  track('track_get_more_notifications_error', fields);

export const trackSetNotificationStateError = (fields = {}) =>
  track('track_set_notification_state_error', fields);

export const trackClearCacheError = (fields = {}) => track('track_clear_cache_error', fields);

export const trackSendCaughtErrorError = (fields = {}) =>
  track('track_send_caught_error_error', fields);

export const trackDigestMessageError = (fields = {}) => track('track_digest_message_error', fields);

export const trackRetrieveAsyncStorageDataError = (fields = {}) =>
  track('track_retrieve_async_storage_data_error', fields);

export const trackStoreAsyncStorageDataError = (fields = {}) =>
  track('track_store_async_storage_data_error', fields);

export const trackForceDeliveryError = (fields = {}) => track('track_force_delivery_error', fields);

export const trackStowBasketError = (fields = {}) => track('track_stow_basket_error', fields);

export const trackRecallRobotError = (fields = {}) => track('track_recall_robot_error', fields);

export const trackRecoverRobotError = (fields = {}) => track('track_recover_robot_error', fields);

export const trackLogoutError = (fields = {}) => track('track_logout_error', fields);

export const trackCateringDraftActionError = (fields = {}) =>
  track('track_catering_draft_action_error', fields);
